import { Box } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import { t } from "i18next";
import dayjs from "dayjs";
import BreadcrumbsTitle from "../../../components/ui/breadcrumbsTitle";
import SelectCheckMarkBranch from "../../../components/ui/select/selectCheckMarkBranch";
import { TextTable } from "../../../components/ui/textfield/textfieldCustom";
import { getAllSaleProduct } from "../../../service/saleProductAPI";
import { MyContext } from "../../../context/MyContext";
import DataTableReport from "../../../components/ui/dataTable/dataTableReport";

function ReportByCategory() {
  const [rows, setRows] = useState([]);

  const [columns, setColumns] = useState([]);
  const [exportColumnName, setExportColumnName] = useState(null);
  const {
    branchAll,
    setBranchSelectReport,
    branchSelectReportDate,
    reportAll,
    fetchReport,
    saleProductSetAll,
  } = useContext(MyContext);

  const [isLoadingData, setIsLoadingData] = useState(
    reportAll.length > 0 ? false : true,
  );
  const fetchData = async () => {
    let headers = [];
    let dataAPISaleProduct =
      saleProductSetAll.length > 0
        ? saleProductSetAll
        : await getAllSaleProduct();
    let dataBranch = [];
    branchAll.forEach((itemBranch) => {
      let dataAllReceipt = reportAll.filter(
        (item) => item.branch_id === itemBranch.id,
      );
      if (dataAllReceipt.length > 0) {
        dataBranch.push({
          branch_id: itemBranch.id,
          receiptAll: dataAllReceipt,
        });
      }
    });

    let dataAllSaleProduct = [];
    dataBranch.forEach((itemBranch) => {
      let dataCollectSaleProduct = [];
      itemBranch.receiptAll
        .filter((itemNoVoid) => itemNoVoid.receipt_status === "success")
        .forEach((itemReceipt) => {
          itemReceipt.receipt_sale_products.forEach((itemSaleProduct) => {
            dataCollectSaleProduct.push({
              branch_id: itemBranch.branch_id,
              id: itemSaleProduct.sale_product_id,
              name: itemSaleProduct.name,
              amount: itemSaleProduct.amount,
              price: itemSaleProduct.price,
              priceAfterDiscount: itemSaleProduct.price_after_discount,
              mainCategory: dataAPISaleProduct.find(
                (itemSaleProductAll) =>
                  itemSaleProductAll.id === itemSaleProduct.sale_product_id,
              )?.main_categories?.[0]?.main_category_lang?.name ?? "None",
              minorCategory:
                dataAPISaleProduct.find(
                  (itemSaleProductAll) =>
                    itemSaleProductAll.id === itemSaleProduct.sale_product_id,
                )?.minor_categories?.length > 0
                  ? dataAPISaleProduct.find(
                      (itemSaleProductAll) =>
                        itemSaleProductAll.id ===
                        itemSaleProduct.sale_product_id,
                    )?.minor_categories[0].minor_category_lang?.name
                  : "None",
              discountByItems:
                (itemSaleProduct.price - itemSaleProduct.price_after_discount) *
                itemSaleProduct.amount,
              branchName: itemReceipt.receipt_config_receipt
                ? itemReceipt.receipt_config_receipt.config_receipt_lang
                    .branch_name
                : null,
            });
          });
        });
      dataAllSaleProduct.push(dataCollectSaleProduct);
    });
    let dataBox = [];
    dataAllSaleProduct.forEach((itemBranch) => {
      let dataItemBrachBoxWithSaleProduct = [];
      itemBranch.forEach((itemAllProduct) => {
        let existingItem = dataItemBrachBoxWithSaleProduct.find(
          (itemFind) => itemFind.id === itemAllProduct.id,
        );
        if (existingItem === undefined) {
          dataItemBrachBoxWithSaleProduct.push(itemAllProduct);
        } else {
          existingItem.amount = existingItem.amount + itemAllProduct.amount;
          existingItem.discountByItems += itemAllProduct.discountByItems;
        }
      });
      dataBox.push(dataItemBrachBoxWithSaleProduct);
    });
    dataBox.forEach((itemReceipt) => {
      itemReceipt.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
      itemReceipt.forEach((itemSaleProduct) => {
        itemSaleProduct.grossSale =
          itemSaleProduct.amount * itemSaleProduct.price;
        itemSaleProduct.discountedPrice =
          itemSaleProduct.grossSale - itemSaleProduct.discountByItems;
      });
    });
    let dataCollectCategory = [];
    dataBox.forEach((itemBranch) => {
      let dataFindMainCategories = [];
      itemBranch.forEach((itemSaleProduct) => {
        let exitingMainCategory = dataFindMainCategories.find(
          (itemMainCategory) =>
            itemMainCategory.mainCategoryName === itemSaleProduct.mainCategory,
        );
        if (exitingMainCategory === undefined) {
          dataFindMainCategories.push({
            mainCategoryName: itemSaleProduct.mainCategory,
            amount: itemSaleProduct.amount,
            branch_id: itemSaleProduct.branch_id,
            grossSale: itemSaleProduct.grossSale,
            discountByItems: itemSaleProduct.discountByItems,
            discountedPrice: itemSaleProduct.discountedPrice,
            branchName: itemSaleProduct.branchName,
          });
        } else {
          exitingMainCategory.amount += itemSaleProduct.amount;
          exitingMainCategory.grossSale += itemSaleProduct.grossSale;
          exitingMainCategory.discountByItems +=
            itemSaleProduct.discountByItems;
          exitingMainCategory.discountedPrice +=
            itemSaleProduct.discountedPrice;
        }
      });
      dataCollectCategory.push(dataFindMainCategories);
    });
    let dataAll = [];

    dataCollectCategory.forEach((item) => {
      item.forEach((itemSaleProduct) => {
        dataAll.push(itemSaleProduct);
      });
    });
    // dataAll.push({
    //   mainCategoryName: "Total",
    //   amount: dataAll.reduce((acc, item) => acc + item.amount, 0),
    //   grossSale: dataAll.reduce((acc, item) => acc + item.grossSale, 0),
    //   discountByItems: dataAll.reduce(
    //     (acc, item) => acc + item.discountByItems,
    //     0
    //   ),
    //   discountedPrice: dataAll.reduce(
    //     (acc, item) => acc + item.discountedPrice,
    //     0
    //   ),
    //   branchName: null,
    // });
    setRows(dataAll);
    let dataColumns = [
      {
        header: t("report_main_category"),
        accessorKey: "mainCategoryName",
        flexGrow: 1,
        Cell: ({ cell }) => <TextTable props={{ text: cell.getValue() }} />,
      },

      {
        header: t("report_amount"),
        accessorKey: "amount",
        isSorting: true,
        minWidth: 50,
        Cell: ({ cell }) => (
          <TextTable
            props={{
              text: Number(cell.getValue()).toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }),
              alignText: "right",
            }}
          />
        ),
      },

      {
        header: t("report_gross_sale"),
        accessorKey: "grossSale",
        isSorting: true,
        flexGrow: 1,
        Cell: ({ cell }) => (
          <TextTable
            props={{
              text: Number(cell.getValue()).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
              alignText: "right",
            }}
          />
        ),
      },
      {
        header: t("report_discount_by_item"),
        accessorKey: "discountByItems",
        isSorting: true,
        flexGrow: 1,
        Cell: ({ cell }) => (
          <TextTable
            props={{
              text: Number(cell.getValue()).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
              alignText: "right",
            }}
          />
        ),
      },
      {
        header: t("report_discounted_price"),
        accessorKey: "discountedPrice",
        isSorting: true,
        flexGrow: 1,
        Cell: ({ cell }) => (
          <TextTable
            props={{
              text: Number(cell.getValue()).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
              alignText: "right",
            }}
          />
        ),
      },

      {
        header: t("report_branch"),
        flexGrow: 1,
        accessorKey: "branchName",
        Cell: ({ cell }) => <TextTable props={{ text: cell.getValue() }} />,
      },
    ];

    dataColumns.forEach((item) => {
      if (item.header !== "Image" && item.header !== "Action") {
        headers.push(item.header);
      }
    });
    setColumns(dataColumns);
    //===== Start set header name export csv
    const csvStringArray = [
      headers,
      ...dataAll.map((item) => [
        item.mainCategoryName,
        item.amount,
        item.grossSale,
        item.discountByItems,
        item.discountedPrice,
        item.branchName,
      ]),
    ]
      .map((row) => row.join(","))
      .join("\n");

    setExportColumnName(csvStringArray);
    //===== End set header name export csv
    setIsLoadingData(false);
  };
  const onConfirm = async () => {
    await setIsLoadingData(true);
    await fetchReport();
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportAll]);
  return (
    <Box>
      <BreadcrumbsTitle
        props={{
          title: t("report_by_category"),
        }}
      />
      <Box>
        <SelectCheckMarkBranch
          props={{
            onConfirm,
            setBranchSelectReport,
          }}
        />

        <DataTableReport
          statusViewMode={true}
          rows={rows}
          isLoadingData={isLoadingData}
          exportColumnName={exportColumnName}
          columns={columns}
          height={0.85}
          fileName={
            t("report_by_category") +
            `${dayjs(branchSelectReportDate.startDate).format(
              "DD/MM/YYYY",
            )} - ${dayjs(branchSelectReportDate.endDate).format("DD/MM/YYYY")}`
          }
        />
      </Box>
    </Box>
  );
}

export default ReportByCategory;
